export enum MasterList {
	LAB,
    MACHINE,
    PRINTER,
    CARRIER_STATUS,
    QC_TYPE,
    BUSINESS_AREA,
    SEQUENCER_CONFIG,
    CHEMICAL,
    MACHINE_TYPE,
    PRODUCT,
    LIB_TYPE,
    ECHO_CONFIGURATION,
    SALES_ITEM_TYPE 
}